import {
  EstadosAgendamientoEnumChoice,
  EstadosContratoChoiceEnum,
  gridSizeMdLg3,
  TABLE_CONSTANTS_COLUMS,
} from "@/shared";
import { fetchAutocompleteFlota, useFetchAgendamientos } from "@/shared/actions/erp";
import { CustomAutocompleteArrStringNoForm, GeneralTable } from "@/shared/components/ui";
import DateRangePicker from "@/shared/components/ui/CustomSearch/DateRangePicker";
import {
  useLoaders,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared/hooks";
import { Agendamiento, FilterEstados, Flota } from "@/shared/interfaces";
import { Grid } from "@mui/material";
import { useRef, useState } from "react";
import Flatpickr from 'react-flatpickr';
import CustomAutocompleteFetch from "@/shared/components/ui/CustomAutocompleteFetch";
import dayjs from "dayjs";
import { useTableColumnsInformeInstalacion } from "@/shared/hooks/useTableColumnsInformeInstalacion";

export default function TableInformeInstalacionProgramadoPyl() {
  const flatpickrRef = useRef<Flatpickr>(null);

  const { columnsInforme } = useTableColumnsInformeInstalacion();


  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const [estados, setEstados] = useState<FilterEstados>({ estadoAgendamiento: null, estadoContrato: null });

  const {
    pagination,
    dateAfterDefault,
    dateBeforeDefault,
    setPagination,
    onChangeRangeDate,
    flota,
    setFlota,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  ///* React Query

  const {
    isLoading,
    data: agendaRes,
    isRefetching,
  } = useFetchAgendamientos({
    enabled: true,
    params: {
      estado_agendamiento_in: estados.estadoAgendamiento,
      contrato_estado_contrato_exclude: EstadosContratoChoiceEnum.EN_ESPERA,
      contrato_estado_contrato: estados.estadoContrato,
      fecha_instalacion_after: dateAfterDefault,
      fecha_instalacion_before: dateBeforeDefault,
      page: pageIndex + 1,
      page_size: pageSize,
      flota: flota,
      ...filterObject
    },
  });



  useLoaders(isLoading || isRefetching);

  return (
    <>
      <Grid container spacing={2}>
        <Grid
          item
          container
          spacing={1}
          alignItems="center"
        >

          <CustomAutocompleteArrStringNoForm
            label="Estado Agendamiento"
            options={[
              EstadosAgendamientoEnumChoice.ALL,
              //EstadosAgendamientoEnumChoice.EN_ESPERA,
              EstadosAgendamientoEnumChoice.FINALIZADO,
              EstadosAgendamientoEnumChoice.RECORDINADO,
              EstadosAgendamientoEnumChoice.GESTION_VENTA,
              EstadosAgendamientoEnumChoice.CANCELADO,
            ]}
            defaultValue={estados.estadoAgendamiento ?? EstadosAgendamientoEnumChoice.ALL}
            size={gridSizeMdLg3}
            onChangeValue={(value) => {

              let estadoAgendamiento: EstadosAgendamientoEnumChoice | null = null;

              switch (value) {
                case EstadosAgendamientoEnumChoice.ALL:
                  estadoAgendamiento = null;
                  break;
                case EstadosAgendamientoEnumChoice.FINALIZADO:
                  estadoAgendamiento = EstadosAgendamientoEnumChoice.FINALIZADO;
                  break;
                case EstadosAgendamientoEnumChoice.RECORDINADO:
                  estadoAgendamiento = EstadosAgendamientoEnumChoice.RECORDINADO;
                  break;
                case EstadosAgendamientoEnumChoice.EN_ESPERA:
                  estadoAgendamiento = EstadosAgendamientoEnumChoice.FINALIZADO;
                  break;
                case EstadosAgendamientoEnumChoice.GESTION_VENTA:
                  estadoAgendamiento = EstadosAgendamientoEnumChoice.PRERECHAZADO
                  break;
                case EstadosAgendamientoEnumChoice.CANCELADO:
                  estadoAgendamiento = EstadosAgendamientoEnumChoice.CANCELADO
                  break;
                default:
                  estadoAgendamiento = value;
                  break;
              }

              setEstados({
                ...estados,
                estadoAgendamiento,
              })

              setPagination({
                pageIndex: 0,
                pageSize: 10
              })
            }}
          />

          <CustomAutocompleteArrStringNoForm
            label="Estado Instalacion"
            options={[
              EstadosContratoChoiceEnum.ALL,
              EstadosContratoChoiceEnum.EN_ESPERA,
              EstadosContratoChoiceEnum.FINALIZADO,
              EstadosContratoChoiceEnum.CANCELADO,
            ]}
            defaultValue={estados.estadoContrato ?? EstadosContratoChoiceEnum.ALL}

            size={gridSizeMdLg3}
            onChangeValue={(value) => {

              let estadoContrato: EstadosContratoChoiceEnum | null = null;

              switch (value) {
                case EstadosContratoChoiceEnum.ALL:
                  estadoContrato = null;
                  break;
                case EstadosContratoChoiceEnum.EN_ESPERA:
                  estadoContrato = EstadosContratoChoiceEnum.SUSPENDIDO;
                  break;
                case EstadosContratoChoiceEnum.FINALIZADO:
                  estadoContrato = EstadosContratoChoiceEnum.ACTIVO;
                  break;
                default:
                  estadoContrato = value;
                  break;
              }

              setEstados({
                ...estados,
                estadoContrato
              })

              setPagination({
                pageIndex: 0,
                pageSize: 10
              })
            }}
          />

          <CustomAutocompleteFetch<Flota>
            size={gridSizeMdLg3}
            label="Flota"
            fetchData={fetchAutocompleteFlota}
            getOptionLabel={(opt) => opt.nombre || ''}
            onChangeValue={(value) => {
              setFlota(value?.nombre ?? '')
            }}
          />

          {onChangeRangeDate && (
            <DateRangePicker
              label="Fecha de instalación"
              size={gridSizeMdLg3}
              flatpickrRef={flatpickrRef}
              onChange={range => onChangeRangeDate(range)}
              defaultValue={dayjs().format('YYYY-MM-DD')}

            />
          )}




        </Grid>

        <Grid item xs={12}>
          <GeneralTable<Agendamiento>
            columns={columnsInforme}
            data={agendaRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={agendaRes?.data?.count}
            // // actions
            actionsColumnSize={TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            // crud
            positionActionsColumn="first"
            enableColumnActions={false}
            canEdit={false}
            showCustomActionBtnSpace={false}
            enableEditing={false}

          />
        </Grid>
      </Grid>

    </>
  );
}
